import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";

const Assets = () => {

  const [assestData, setAssestData] = useState([])


  const { data, loading, error } = useApi("/api/get-assets-employee", {
    method: "GET",
    autoCall: true
  })

  useEffect(() => {
    if (data?.success) {
      const finalData = data?.data.map((item: any, index: any) => {
        return {
          ...item,
          key: index + 1
        }
      })
      setAssestData(finalData)
    }
  }, [data])

  console.log(assestData)

  const columns = [
    {
      title: "S No",
      dataIndex: "key",
      render: (text: String) => <p className="fs-14 fw-medium">{text}</p>,
      sorter: (a: any, b: any) => a.key.length - b.key.length,
    },
    {
      title: "Category",
      dataIndex: "ass_category",
      render: (text: String) => <p className="fs-14 fw-medium">{text}</p>,
      sorter: (a: any, b: any) => a.ass_category.length - b.ass_category.length,
    },
    {
      title: "Name",
      dataIndex: "asset_name",
      render: (text: String) => <p className="fs-14 fw-medium">{text}</p>,
      sorter: (a: any, b: any) => a.asset_name.length - b.asset_name.length,
    },
    // {
    //   title: "Purchase Date",
    //   dataIndex: "purchased_date",
    //   sorter: (a: any, b: any) =>
    //     a.purchased_date.length - b.purchased_date.length,
    // },
    // {
    //   title: "Warrenty",
    //   dataIndex: "warranty",
    //   sorter: (a: any, b: any) => a.warranty.length - b.warranty.length,
    // },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      sorter: (a: any, b: any) => a.manufacturer.length - b.manufacturer.length,
    },
    {
      title: "Serial Number",
      dataIndex: "serial_number",
      sorter: (a: any, b: any) => a.serial_number.length - b.serial_number.length,
    },
    {
      title: "Status",
      dataIndex: "history_status",
      render: (text: string, record: any) => (
        <>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${text === "Allocated"
              ? "badge-success"
              : "badge-danger"

              }`}
          >
            <i className="ti ti-point-filled me-1"></i>
            {text}
          </span>
        </>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    }
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Assets</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Assets
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Assets Lists */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Assets List</h5>
            </div>
            <div className="card-body p-0">
              <Table dataSource={assestData} columns={columns} Selection={false} limit={10}  showSearchInput={true}/>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Assets;
